import DIApi from './_diApi';

class AutoBusinessAPI extends DIApi {
  controllerName = 'AutoBusinesss';
}

export default new AutoBusinessAPI();
